import React, { useEffect, useState, useRef } from "react";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import { Button, Grid, MenuItem, Typography } from "@mui/material";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { NavigateFunction, useNavigate } from "react-router-dom";
import FilterSelect from "../../../components/select/filterSelect";
import CardChat from "../../../components/card/CardChat";
import CustomStatus from "../../../components/chip/CustomStatus";
import { FiberManualRecord } from "@mui/icons-material";
import InputTextField from "../../../components/input/inputTextField";
import { useDispatch, useSelector } from "react-redux";
import { advisorTypeApi } from "../../../api/advisor-type/advisor-type.api";
import { advisorApi } from "../../../api/advisor/advisor.api";
import { EmployeeApi } from "../../../api/employee/employee.api";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { advisorStudentApi } from "../../../api/advisor-student/advisor-student.api";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { dataEvaluation } from "../../../utils/usage_form_evluation";
import AutocompleteSelect from "../../../components/select/autoCompleteSelect";
import {
  handleColorStatusConsultRequestUtil,
  handleTextStatusConsultRequestUtil,
} from "../../../utils/statusRequest";
import { facultyApi } from "../../../api/factulty/factulty.api";
import VotingEvaluation from "./VotingEvaluationReport";
import { colors } from "../../../constants/colors";
import { icons } from "../../../assets/icons/icons";
import { ReportApi } from "../../../api/report/Report.api";
import { getToken } from "../../../utils/app.utils";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";

const ReportConsultationRequestDetail = () => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((state: any) => state.profile);
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const grade_level = queryParams.get("grade_level");
  const faculty_name = queryParams.get("faculty_name");

  const [singleDataStudent, setSingleDataStudent] = useState<any>({});

  const [inputValue, setInputValue] = useState({
    selected_usage_type: "",
    selected_advisor_type: 0,
    selected_advisor_type_name: "",
    selected_advisor_id: 0,
    selected_employee_id: 0,
    selected_faculty_id: 0,
    detail: "",
    new_message: "",
    //
    status: "",
    last_updated_by: "",
  });

  const [singleData, setSingleData] = useState<any>({});
  const [faculty, setFaculty] = useState<any[]>([]);

  const [chatDetail, setChatDetail] = useState<any[]>([]);

  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);
  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const [isNewRequest, setIsNewRequest] = useState(false);

  const handleChangeValue = (name: string, value: any) => {
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getAdvisorType = async () => {
    const res = await advisorTypeApi.getAllAdvisorType();

    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  const getDataAdvisor = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await advisorApi.getAllAdvisor(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisor(data.data.items);
    } else {
      setDataAdvisor([]);
    }
  };

  const getDataEmployee = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await EmployeeApi.list(query);
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  const getFaculty = async () => {
    const res = await facultyApi.getAllFaculty();

    const data = res.data;
    if (data.status < 300) {
      setFaculty(data.data);
    } else {
      setFaculty([]);
    }
  };

  useEffect(() => {
    getAdvisorType();
    getDataAdvisor();
    getDataEmployee();
    getFaculty();
  }, []);

  const getSingleDataConsultation = async (id: number) => {
    const res = await advisorStudentApi.getAdvisorStudentById(id);
    const data = res.data;
    if (data.status < 300) {
      let parsedAdvisorStudentDetail = {} as any;

      try {
        parsedAdvisorStudentDetail = JSON.parse(
          data?.data.advisor_student_detaill
        );
      } catch (error) {
        console.error("Error parsing advisor_student_detaill:", error);
      }

      setSingleDataStudent(data.data?.student);

      setInputValue({
        selected_usage_type: data.data?.advisor_group ?? "-",
        selected_advisor_type: parsedAdvisorStudentDetail?.advisor_type ?? 0,
        selected_advisor_type_name:
          parsedAdvisorStudentDetail?.advisor_type_name ?? "-",
        selected_advisor_id: data.data?.id_advisor ?? "-",
        selected_employee_id: data.data?.id_employee ?? "-",
        selected_faculty_id: parsedAdvisorStudentDetail.faculty_id ?? "-",
        detail: parsedAdvisorStudentDetail.detail ?? "-",
        new_message: "",
        status: parsedAdvisorStudentDetail.status ?? "",
        last_updated_by: parsedAdvisorStudentDetail.last_updated_by ?? "",
      });
      setSingleData(parsedAdvisorStudentDetail);

      const fileData = data.data.advisorStudentFile ?? [];
      const chatData = parsedAdvisorStudentDetail.chat;

      const mergedData = [
        // Map chat data
        ...chatData.map((chat: any) => ({
          chat_id: chat.chat_id,
          chat_type: chat.chat_type,
          message: chat.message,
          send_date: chat.send_date,
          send_by: chat.send_by,
          send_to: chat.send_to,
          content_type: "text",
          file: null,
        })),
        // Map file data
        ...fileData.map((file: any) => ({
          chat_id: file.id_advisor_student_file,
          chat_type: "file",
          message: null,
          send_date: file.created_date,
          send_by: file.created_id,
          send_to: null, // Use the same `send_to` as chat
          content_type: "file",
          file,
        })),
      ];

      const uniqueMergedData = mergedData.reduce((acc, item) => {
        // Check if the chat_id already exists in the accumulator
        if (
          !acc.some(
            (existingItem: any) => existingItem.chat_id === item.chat_id
          )
        ) {
          acc.push(item); // Add item if it's not a duplicate
        }
        return acc;
      }, []);

      setChatDetail(uniqueMergedData ?? []);

      console.log("mergedChatDetails", mergedData);
    } else {
      setInputValue({
        selected_usage_type: "",
        selected_advisor_type: 0,
        selected_advisor_type_name: "",
        selected_advisor_id: 0,
        selected_employee_id: 0,
        selected_faculty_id: 0,
        detail: "",
        new_message: "",
        status: "",
        last_updated_by: "",
      });
      setSingleData({});
      setChatDetail([]);
    }
  };

  useEffect(() => {
    if (id) {
      getSingleDataConsultation(+id);
    }
  }, [id]);

  const handleSave = async (
    id: number,
    prevData: any,
    prevChat: any,
    body: any
  ) => {
    if (profile && id && body.new_message !== "") {
      try {
        dispatch(unsetLoading());

        const bodyJson = {
          ...prevData,
          last_updated_by:
            profile && profile.user_type === "student" ? "student" : "advisor",
          status: "new_request",
          chat: [
            ...(prevChat ?? []),
            {
              chat_id: new Date().getTime(),
              chat_type:
                profile && profile.user_type === "student"
                  ? "student"
                  : "advisor",
              message: body.new_message,
              send_date: new Date(),
              send_by: (profile && profile.id_user) ?? 0,
              send_to:
                profile && profile.user_type === "student"
                  ? body.selected_employee_id
                  : 0,
            },
          ],
        };

        const newBody = {
          advisor_student_detaill: JSON.stringify(bodyJson),
        };

        const response = await advisorStudentApi.updateAdvisorStudent(
          +id,
          newBody
        );
        if (response.status < 300) {
          alertSuccess(
            "ส่งเรื่องขอคำปรึกษา",
            "ส่งเรื่องขอคำปรึกษา เรียบร้อยแล้ว",
            undefined,
            () => {
              getSingleDataConsultation(+id);
              setIsNewRequest(false);
            }
          );
        }
      } catch (error) {
        alertError("ส่งเรื่องขอคำปรึกษา ไม่สำเร็จ");
      } finally {
        dispatch(unsetLoading());
      }
    } else {
      alertError("ข้อมูลไม่ครบถ้วน");
    }
  };

  const captureRef = useRef<HTMLDivElement>(null);

  const local_token: string | undefined | null = getToken();

  const handleDownloadFile = async (id: number, token: string) => {
    dispatch(setLoading());

    await ReportApi.export_pdf(id, token, {
      grade_level:grade_level,
      faculty_name:faculty_name
    })
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `${
            "report-advisor" + new Date().getTime()
          }.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  return (
    <div>
      <div className="h-auto">
        {/* breadcrumbs */}
        <NavigateListCustom
          navigateData={[
            {
              name: "รายงานการให้คำปรึกษา",
              key: "1",
              pathName: routeName.cms.consultingReport,
            },
            {
              name: "คำขอปรึกษา",
              key: "2",
              pathName: routeName.cms.consultingReport + "/" + id,
            },
          ]}
        />

        {/* header */}
        <section className="my-4 flex justify-between">
          <Typography variant="h3">
            ส่งเรื่องขอคำปรึกษา{" "}
            {/* <CustomStatus
            label={"รอตรวจสอบ"}
            type="outlined"
            color={"warning"}
            icon={<FiberManualRecord />}
          /> */}
            <CustomStatus
              label={handleColorStatusConsultRequestUtil(
                inputValue?.status,
                profile && profile.user_type
              )}
              type="outlined"
              color={handleTextStatusConsultRequestUtil(inputValue?.status)}
              icon={<FiberManualRecord />}
              width="250px"
            />
          </Typography>

          <Button
            variant="outlined"
            sx={{
              backgroundColor: colors.danger,
              color: "white",
              border: colors.danger,
              "&:hover": {
                backgroundColor: colors.danger, // Retain the same background color
                borderColor: colors.danger, // Retain the same border color
              },
            }}
            startIcon={<img src={icons.icon_pdf} alt="start-icon" />}
            onClick={() => {
              if (id && local_token) {
                handleDownloadFile(+id, local_token);
              }
            }}
          >
            ดาวน์โหลด PDF
          </Button>
        </section>
        <div ref={captureRef} style={{ background: "#fff", padding: "16px" }}>
          <Grid container spacing={2} alignItems="starts">
            <Grid item xs={12} sm={3.5}>
              <Typography variant="subtitle1">
                ชื่อ - นามสกุล :{" "}
                {(singleDataStudent &&
                  singleDataStudent.student_frist_name +
                    " " +
                    singleDataStudent.student_last_name) ??
                  ""}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Typography variant="subtitle1">
                ฉายา :{" "}
                {(singleDataStudent && singleDataStudent.student_middle_name) ??
                  ""}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography variant="subtitle1">
                รหัสประจำตัวนักศึกษา :{" "}
                {(singleDataStudent && singleDataStudent.student_no) ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={1}>
              <Typography variant="subtitle1">
                ชั้นปีที่ : {grade_level ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={2.5}>
              <Typography variant="subtitle1">
                หลักสูตร : {faculty_name ?? ""}
              </Typography>
            </Grid>
          </Grid>

          <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
            <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
              <FilterSelect
                heading={"เลือกประเภท"}
                value={inputValue.selected_usage_type ?? ""}
                labelId="type-id"
                selectId="type-select-id"
                options={[
                  {
                    id_type: "",
                    type_name: "เลือกประเภท",
                  },
                  ...dataEvaluation.map((list) => ({
                    id_type: list.id,
                    type_name: list.name,
                  })),
                ].map((list, index) => (
                  <MenuItem value={list.id_type} key={index + 1}>
                    {list.type_name}
                  </MenuItem>
                ))}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeValue("selected_usage_type", e.target.value)
                }
                disabled
              />
            </article>

            {inputValue &&
              inputValue.selected_usage_type ===
                "อาจารย์ที่ปรึกษาประจำชั้น" && (
                <>
                  <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                    <InputTextField
                      heading={"ประเภทคำปรึกษา"}
                      value={inputValue.selected_advisor_type_name}
                      disabled
                    />
                  </article>

                  <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
                    <AutocompleteSelect
                      heading={"อาจารย์ที่ต้องการปรึกษา"}
                      freeSolo
                      labelId={"-"}
                      options={dataAdvisor ?? []}
                      getOptionLabel={(option: any) =>
                        inputValue.selected_advisor_id &&
                        dataAdvisor &&
                        dataAdvisor.length > 0
                          ? dataAdvisor.find(
                              (data: any) =>
                                data.id_advisor ===
                                inputValue.selected_advisor_id
                            )?.first_name +
                            " " +
                            dataAdvisor.find(
                              (data: any) =>
                                data.id_advisor ===
                                inputValue.selected_advisor_id
                            )?.last_name
                          : ""
                      }
                      value={"-"}
                      disabled
                    />
                  </article>
                </>
              )}

            {inputValue &&
              inputValue.selected_usage_type ===
                "อาจารย์ที่ปรึกษาประจำรายวิชา" && (
                <>
                  <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12"></article>

                  <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                    <AutocompleteSelect
                      heading={"รายวิชา"}
                      freeSolo
                      labelId={"-"}
                      options={faculty ?? []}
                      value={
                        faculty.find(
                          (x: any) =>
                            x?.id_faculty === inputValue.selected_faculty_id
                        ) || null
                      }
                      getOptionLabel={(option: any) =>
                        `${option?.faculty_name}` || ""
                      }
                      renderOption={(props, option) => (
                        <li {...props}>{`${option?.faculty_name}`}</li>
                      )}
                      disabled
                    />
                  </article>

                  <article className="w-full col-span-12 lg:col-span-6 md:col-span-6 sm:col-span-12">
                    <InputTextField
                      heading={"อาจารย์ที่ต้องการปรึกษา"}
                      // value={dataEmployee}
                      value={
                        dataEmployee.find(
                          (x: any) =>
                            x?.id_employee === inputValue.selected_employee_id
                        )?.fullname || null
                      }
                      disabled
                    />
                  </article>
                </>
              )}

            <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mt-4">
              <CardChat
                data={
                  (chatDetail &&
                    chatDetail?.map((item: any, index: number) => ({
                      id: item.chat_id,
                      type:
                        item.chat_type === "student"
                          ? "นักศึกษา"
                          : "อาจารย์ที่ปรึกษา",
                      sender: item.chat_type !== "student" ? "me" : "you",
                      message: item.message,
                      date: item.send_date,
                      content_type: item.content_type,
                      file: item.file,
                    }))) ??
                  []
                }
              />
            </article>

            {isNewRequest && (
              <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12">
                <InputTextField
                  heading={"รายละเอียด"}
                  placeholder={"ระบุรายละเอียด"}
                  value={inputValue.new_message}
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangeValue("new_message", e.target.value)
                  }
                  row={3}
                  maxRows={5}
                  disablePaddingMultiline
                  multiline
                  inputHeight={"auto"}
                />
              </article>
            )}
          </div>

          <article className="w-full col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 mt-4">
            <VotingEvaluation id={id ? +id : 0} />
          </article>
        </div>

        <section
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "24px",
          }}
        >
          <ButtonOutlined
            onClick={() => {
              navigate(routeName.cms.consultingReport);
            }}
            mode="del"
            buttonName="ยกเลิก"
            btnProps={{
              width: "200px",
              margin: "12px",
            }}
          />
        </section>
      </div>
    </div>
  );
};

export default ReportConsultationRequestDetail;
